import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setArticleBaseModal } from '../actions/modalActions'
import { toggleKeyboard } from '../../actions/layoutActions'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import ArticleBaseListItem from '../../components/ArticleBaseListItem'
import $ from 'jquery'
import * as resource from '../../constants/Resources'
import { getTranslation } from '../../actions/dataActions'

class ArticleBaseModal extends Component {
    constructor(props) {
        super(props);
        this.cancelTap = this.cancelTap.bind(this);
        this.removeTap = this.removeTap.bind(this);
        this.resetTap = this.resetTap.bind(this);
        this.updateInputField = this.updateInputField.bind(this);
        this.processTouchTap = this.processTouchTap.bind(this);
        this.showKeyboard = this.showKeyboard.bind(this);
        this.filterArticles = this.filterArticles.bind(this);
        this.state = {
            inputField: ''
        };
    }

    cancelTap() {
        this.props.setArticleBaseModal([], false, 'default');
    }

    removeTap() {
        this.processTouchTap(null);
        this.props.setArticleBaseModal([], false, 'default');
    }

    resetTap() {
        $('#search').val('');
        this.setState({ inputField: '' });
    }

    processTouchTap(article) {
        const callback = this.props.articleBaseModal.callback;
        const dispatch = this.props.articleBaseModal.dispatch;

        let callbackParams = [article];

        if (this.props.articleBaseModal.callbackparams !== undefined) {
            this.props.articleBaseModal.callbackparams.map(param => {
                callbackParams.push(param);
                return '';
            })
        }

        this.setState({ inputField: '' });
        this.props.setArticleBaseModal([], false, 'default');

        if (callback !== null) {
            if (dispatch !== null) {
                dispatch(callback.apply(this, callbackParams));
            } else {
                callback.apply(this, callbackParams);
            }
        }
    }

    updateInputField(input) {
        this.setState({ inputField: input });
    }

    showKeyboard() {
        this.setState({ inputField: '' });
        this.props.toggleKeyboard(true, '#search',  this.props.getTranslation(resource.SEARCH_TERM), this.updateInputField, [$('#search').val()]);
    }

    filterArticles(articles, inputField) {
        let newlist = articles.filter((a) => {
            let articlenumber = a.ArticleNumber != null? a.ArticleNumber.toLowerCase():'';
            let description = a.Description != null? a.Description.toLowerCase():'';
            let input = inputField.toLowerCase();
            let barcodeMatch = a.Barcodes != null && a.Barcodes.some(b => b != null && b.toLowerCase().includes(input));
    
            return articlenumber.includes(input) || description.includes(input) || barcodeMatch
        });
    
        return newlist;
    }

    render() {
        const newList = this.filterArticles(this.props.articleBaseModal.listvalues, this.state.inputField);
        return (
            <Modal className='articleBaseModal'
                contentLabel=""
                isOpen={this.props.articleBaseModal.show}
                style={properties.articleBaseModalStyle}
            >
                <div className="articleBaseModal_header">
                    <div className="header_top">
                    {this.props.getTranslation(resource.ARTICLE_LIST)}
                    </div>
                </div>
                <div className="articleBaseModal_content">
                    <div>
                        <div className="search_bar_div">
                            <input
                                id="search"
                                className="search_bar"
                                placeholder={this.props.getTranslation(resource.SEARCH_TERM)}
                                onClick={this.showKeyboard}
                                readOnly="readOnly" />
                            {this.state.inputField !== '' &&
                                <button className="btnReset" onClick={this.resetTap} >
                                   {this.props.getTranslation(resource.RESET)}
                                </button>
                            }
                        </div>
                        <div className="articleList" >
                            {
                                newList.slice(0, 300).sort((a, b) => (a.Description > b.Description) ? 1 : -1).map(art =>
                                    <ArticleBaseListItem
                                        key={art.ArticleId}
                                        Article={art}
                                        Callback={this.processTouchTap}
                                    />
                                )
                            }
                        </div>
                    </div>
                </div>
                <div className="articleBaseModal_footer">
                    <button className="btnCancel" style={{ width: "100%" }} onClick={this.cancelTap} >
                    {this.props.getTranslation(resource.CANCEL)}
                    </button>
                </div>

            </Modal>
        )
    }
}

ArticleBaseModal.propTypes = {
}


function mapStateToProps(state) {
    return {
        articleBaseModal: state.modalState.articleBaseModal,
        keyboard: state.layoutState.keyboard,
    }
}

export default connect(mapStateToProps, {
    setArticleBaseModal,
    toggleKeyboard,
    getTranslation
})(ArticleBaseModal)



// WEBPACK FOOTER //
// src/modal/components/ArticleBaseModal.jsx